import i18n from "i18next";

import { useLoadDatasourceConfigurationsQuery } from "../../../services/serverApi";
import type { CellValue } from "../../../types/types";

interface CellEnumProps {
    cellValue: CellValue;
    datasource: string;
}

export const CellEnumValue = ({ cellValue, datasource }: CellEnumProps) => {
    const { data } = useLoadDatasourceConfigurationsQuery(datasource);

    const matched = data?.items?.find((item) => String(item.value) === String(cellValue));

    return <span>{matched?.key ? i18n.t(matched.key) : ""}</span>;
};
